import { useState } from "react";
import ServicesBlockContent from "./services-block-content/services-block-content";
import ServicesBlockMenu from "./services-block-menu/services-block-menu";
import "./services-block.sass";

const ServicesBlock = () => {
  const [selected, setSelected] = useState(0);

  return (
    <div className="services-block">
      <div className="services-block__left">
        <div className="services-block__title">что мы умеем</div>

        <ServicesBlockMenu selected={selected} setSelected={setSelected} />
      </div>

      <ServicesBlockContent selected={selected} />
    </div>
  );
};

export default ServicesBlock;
